import { NgClass, NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import { MatMenuItem } from '@angular/material/menu';

import { ClientAccess } from '@core/models/client-access';
import { DataCySlugPipe } from '@shared/pipes/data-cy-slug.pipe';
import { SortPipe } from '@shared/pipes/sort.pipe';

@Component({
  selector: 'app-client-picker',
  templateUrl: './client-picker.component.html',
  styleUrls: ['./client-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, NgStyle, MatMenuItem, DataCySlugPipe, SortPipe]
})
export class ClientPickerComponent {
  readonly clients = input.required<ClientAccess[]>();
  readonly selectedClientId = input.required<string>();
  readonly disabled = input.required<boolean>();

  readonly selected = output<ClientAccess>();

  onClientChange(client: ClientAccess): void {
    this.selected.emit(client);
  }
}
